export enum Gender {
    MALE = 1,
    FEMALE = 2,
    NON_BINARY = 3
}